import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Translate } from 'core/translate';
import { Button, ButtonIcon, ButtonText } from 'core/controls/button/Button';
import { combineClassNames } from 'core/css';

const FINANCE = 'finance';
const LEASE = 'lease';

const computeActiveTab = (showFinance, showLease) => {
  if (!showFinance && !showLease) {
    return '';
  }

  if (!showFinance && showLease) {
    return 'lease';
  }

  return 'finance';
};

const FinancingHeader = ({
  header,
  visible,
  anaytlicsKey,
  isActive,
  onClick,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <div
      className={combineClassNames(
        'option-tabs__tab',
        'stat-button-link',
        isActive ? 'option-tabs__tab--active' : ''
      )}
      data-dtm={anaytlicsKey}
      onClick={onClick}>
      <div
        className={combineClassNames(
          'option-tabs__label-outer',
          isActive ? 'option-tabs__label-outer--active' : ''
        )}>
        <Translate value={header} />
      </div>
    </div>
  );
};

const FinanceOptionsTabs = ({ activeTab, onClick, showFinance, showLease }) => {
  return (
    <div className="finance-options__tabs option-tabs__tablist">
      <FinancingHeader
        header={'component.pricing.finance.header'}
        visible={showFinance}
        isActive={activeTab === FINANCE}
        onClick={() => onClick(FINANCE)}
        anaytlicsKey={`payment options`}
      />
      <FinancingHeader
        header={'component.pricing.lease.header.v3'}
        visible={showLease}
        onClick={() => onClick(LEASE)}
        isActive={activeTab === LEASE}
        anaytlicsKey={`payment options`}
      />
    </div>
  );
};

const FinanceContent = ({ activeTab }) => {
  return (
    <Fragment>
      <div
        style={{ display: `${activeTab === FINANCE ? 'block' : 'none'}` }}
        className="finance-options__content">
        <span className="finance-options__content-finance__header">
          <Translate value="pe.tab.header.finance.v3" />
        </span>
        <div className="finance-options__content-finance">
          <gmst-pe-finance-summary />
          <div className="finance-options__cta-container">
            <Button
              as={Link}
              analytics="text"
              to="payment"
              className="finance-options__adjust-payment-button stat-button-link"
              data-dtm="payment options:finance">
              <ButtonIcon className="button__icon--left" name="calculator" />
              <ButtonText>
                <Translate value="component.pricing.estimate.payments" />
              </ButtonText>
            </Button>
          </div>
        </div>
      </div>
      <div
        style={{ display: `${activeTab === LEASE ? 'block' : 'none'}` }}
        className="finance-options__content">
        <span className="finance-options__content-lease__header">
          <Translate value="pe.tab.header.lease.v3" />
        </span>
        <div className="finance-options__content-lease">
          <gmst-pe-lease-summary />
          <div className="finance-options__cta-container">
            <Button
              as={Link}
              analytics="text"
              to="payment?initialTab=lease"
              className="finance-options__adjust-payment-button stat-button-link"
              data-dtm="payment options:lease">
              <ButtonIcon className="button__icon--left" name="calculator" />
              <ButtonText>
                <Translate value="component.pricing.estimate.payments" />
              </ButtonText>
            </Button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

class SummaryFinanceContent extends Component {
  constructor(props) {
    super(props);

    const { showFinance, showLease } = this.props;

    this.state = {
      activeTab: computeActiveTab(showFinance, showLease),
    };
  }

  onClick = (type) => {
    this.setState({ activeTab: type });
  };

  componentDidUpdate(prevProps) {
    const { showFinance, showLease } = this.props;

    if (
      showFinance !== prevProps.showFinance ||
      showLease !== prevProps.showLease
    ) {
      this.setState({
        activeTab: computeActiveTab(showFinance, showLease),
      });
    }
  }

  render() {
    const { showFinance, showLease } = this.props;
    const activeTab = this.state.activeTab;

    return (
      <div
        id="financing-options"
        className="finance-options__container summary__financing-options">
        <div className="finance-options__container">
          <FinanceOptionsTabs
            activeTab={activeTab}
            onClick={this.onClick}
            showFinance={showFinance}
            showLease={showLease}
          />
          <FinanceContent activeTab={activeTab} />
        </div>
      </div>
    );
  }
}

export default SummaryFinanceContent;
